module.exports = "/assets/pattern.png?Ar4pHHT";